import { useMutation, useQuery, useQueryClient, useSuspenseQuery } from "@tanstack/react-query";
import { SERVER } from "../server";

const authStateQuery = {
  queryKey: ["authState"] as const,
  retry: false,
  queryFn: async () => {
    try {
      return await SERVER.v1.getApiV1AdminPortalAccount();
    } catch {
      return null;
    }
  },
};

/** Same cache as `useAuthState`, without Suspense (e.g. root-level UI with no boundary). */
export function useAuthStateQuery() {
  return useQuery(authStateQuery);
}

export default function useAuthState() {
  const client = useQueryClient();
  const { data } = useSuspenseQuery(authStateQuery);

  const logout = useMutation({
    mutationFn: () => SERVER.v1.postApiV1AdminPortalAuthLogout(),
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: ["authState"],
      });
    },
  });

  return {
    authState: data,
    logout: logout.mutate,
  };
}
